import { render, staticRenderFns } from "./TemplateComposer.vue?vue&type=template&id=047c10d3&scoped=true"
import script from "./TemplateComposer.vue?vue&type=script&lang=js"
export * from "./TemplateComposer.vue?vue&type=script&lang=js"
import style0 from "./TemplateComposer.vue?vue&type=style&index=0&id=047c10d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c10d3",
  null
  
)

export default component.exports